import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { OrderByPipe } from '../../../pipes/order-by.pipe';
import { LocaleService } from '../../../services/locale.service';
import { Person } from '../../../models/person';

@Component({
	selector: 'app-contribuente-mobili',
	templateUrl: './contribuente-mobili.component.html',
	styleUrls: ['./contribuente-mobili.component.css']
})
export class ContribuenteMobiliComponent implements OnInit {

	@ViewChild('mobModal') mobModal: ModalDirective;
	@Input() idPerson : any = 0;
	@Input() writePermission: boolean = false;
	person = new Person();
	anagraficaSync:Subscription;
	mobiliSync:Subscription;
	mobili: any[] = [];
	editable: any = {};

	constructor(
		private dataService: DataService,
		private formatter: LocaleService
		) { }

	ngOnInit() {
		this.anagraficaSync = this.dataService.getContribuentiService().anagrafica$.subscribe(
			() => {
				if (this.idPerson) {
					this.dataService.getPersonById(this.idPerson, (person) => {
						this.person = person;
					});
				}
			});
		this.mobiliSync = this.dataService.beniMobili$.subscribe(
			() => {
				if (this.idPerson) {
					this.mobili = this.dataService.getMobiliByPersonId(this.idPerson);
				}
			});
	}

	ngOnChanges(changes: any){
		if(changes.idPerson && this.idPerson > 0){

			this.mobili = this.dataService.getMobiliByPersonId(this.idPerson);

			this.dataService.getPersonById(this.idPerson, (person) => {
				if (person) {
					this.person = person;
				}
				else {
					this.person = new Person(this.idPerson);
				}
			});
		}
	}

	editFunction(row:any){
		return !this.editable[row.id];
	}

	discard(row:any){
		this.editable[row.id] = false;
	}

	commit(row:any){
		this.editable[row.id] = false;
	}

	aggiungiMobile(row:any){
		row = {};
		row.altro_fermo_importo = 0;
		this.mobili.push(row);
	}

	modificaMobile(row:any){
		this.editable[row.id] = true;
	}

	eliminaMobile(row:any){
		let what = row;
		let index = this.mobili.indexOf(what);
		if(index !== -1){
			this.mobili.splice(index, 1);
		}
	}

	reset(){
		for (let row of this.mobili){
			this.editable[row.id] = false;
		}
	}

	show() {
		this.reset();
		this.mobModal.show();
	}

	hide(){
		this.mobModal.hide();
	}

	ngOnDestroy() {
		this.anagraficaSync.unsubscribe();
		this.mobiliSync.unsubscribe();
	}

}
